import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Forces the window to scroll to the top whenever the route changes.
 * Drop this anywhere inside <Router> — it renders nothing.
 */
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
};
